const mediaOrigins = new Set<string>();

/** Runtime metadata comes only from the application's own API responses. */
export function registerMediaOrigin(value: unknown): void {
  if (typeof value !== "string") return;
  try {
    const url = new URL(value);
    if (url.protocol === "https:" && url.origin === value) mediaOrigins.add(url.origin);
  } catch {
    /* Not a configured origin. */
  }
}

export function mediaKeyFromUrl(value: unknown): string | null {
  if (typeof value !== "string" || !value) return null;
  try {
    const url = new URL(value, window.location.origin);
    if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) return null;
    const apiOrigin = new URL(
      import.meta.env.VITE_SERVER_URL || window.location.origin,
      window.location.origin,
    ).origin;
    if (
      [window.location.origin, apiOrigin].includes(url.origin) &&
      url.pathname === "/api/s3-proxy"
    )
      return url.searchParams.get("key");
    if (url.hostname.endsWith(".amazonaws.com") || mediaOrigins.has(url.origin)) {
      const key = decodeURIComponent(url.pathname.slice(1));
      return key.startsWith("users/") ? key : null;
    }
  } catch {
    /* External or malformed URL. */
  }
  return null;
}
